import React, { useState } from 'react'
import { Button, Icon } from '@arnsbogroup/react-voicearchive'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'
import messages from './messages'

const CreateOrder = ({ customer, isCustomerDataComplete }) => {
  const { formatMessage } = useIntl()
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const createOrder = () => {
    setLoading(true)
    fetch(`/rest/v2/order/skeleton`, {
      method: 'POST',
      body: JSON.stringify({customerId: customer.uid})
    })
    .then((response) => response.json())
    .then(({success, data, errors}) => {
      setLoading(false)
      if (success) {
        history.push(`/orders/${data.uid}/overview`)
      } else {
        toastr.error(errors)
      }
    }).catch((error) => {
      toastr.error(error)
    })
  }

  return (
    <div className="flex space-x-2">
      { !isCustomerDataComplete &&
        <div className='my-auto'>
          <Icon className="text-negative" icon={["fa","info-circle"]} title={formatMessage(messages.customerDataNotComplete)} />
        </div>
      }
      <Button
        size='sm'
        disabled={!isCustomerDataComplete}
        onClick={() => createOrder()}
        errors={!isCustomerDataComplete ? formatMessage(messages.customerDataNotComplete) : ''}
      >
        {loading ? formatMessage(messages.loading) : formatMessage(messages.createOrder)}
      </Button>
    </div>
  )
}

export default CreateOrder
